import React from 'react';

import { OrderTypes } from '../constants/orderTypeConstants';
import HybridSALandingPage from '../pages/HybridSALandingPage';
import IPENCXLandingPage from '../pages/IPENCXLandingPage';
import OrderDetailsPage from '../pages/OrderDetailsPage';
import { useAppSelector } from '../redux-store/hooks';
import { RootState } from '../redux-store/store';

const OrderDetailsRouter = () => {
  const order: any = useAppSelector((state: RootState) => state.orders.order);
  const getOrderDetailsPage = () => {
    if (
      order?.OrderType?.Type === OrderTypes.IPEN &&
      order?.OrderType?.Vendor === 'Solex'
    ) {
      return <IPENCXLandingPage />;
    } else if (
      order?.OrderType?.Type === OrderTypes.HybridEClose &&
      order?.OrderType?.Vendor === 'Solex'
    ) {
      return <HybridSALandingPage />;
    } else {
      // All other order type goes to this page until we get to create more specific pages based on each order type
      return <OrderDetailsPage />;
    }
  };
  return <>{getOrderDetailsPage()}</>;
};

export default OrderDetailsRouter;
